//
// Javascript for the HEINoty control
//
//  Drew McMinn
//  December 2012
//
HEIJS.registerNamespace("HEIJS.Controls");
HEIJS.Controls.NotyMessage = function (PrimaryMessage, iconCss, clearExisting, notyObject, container)
{
  this.messages = [];
  this.title = PrimaryMessage;
  this.iconCss = iconCss;
  this.clearExisting = clearExisting;
  this.notyObj = notyObject;
  this.container = $(container);
  this.setupEvents();
};

HEIJS.Controls.NotyMessage.prototype =
{
  //
  // Properties
  //
  container: null,
  title: null,
  iconCss: null,
  clearExisting: true,
  messages: [],
  notyObj: null,
  iconMarkup: '<span class="{0}" style="border:0;"><span class="ui-icon {1}"></span></span>',
  notyTemplate: '<div class="noty_message">{0}<span class="noty_text"></span><div class="noty_close"></div></div>',
  darkIconWrap: 'ui-state-active',
  lightIconWrap: 'ui-state-error',
  
  //
  // Methods
  //
  addMessage: function (message)
  {
    this.messages.push(message);
  },
  
  clearMessages: function () {
	this.messages = [];
  },
  
  clearExistingNoty: function () {
	//$.noty.closeAll();
  },
  
  createListFromArray: function (arr) {
    var ul = $('<ul></ul>');
    $.each(arr, function (i) {
      var li = $('<li/>')
          .text(arr[i])
          .appendTo(ul);
    });
    return ul;
  },
  
  showMessages: function () {
	if (this.clearExisting) {
		this.clearExistingNoty();
	}
	if (this.title || this.messages.length > 0) {
		if (this.iconCss) {
			var iconWrap = '';
			switch (this.notyObj['type'])
			{
				case 'info': case 'success': case 'alert': case 'notification': case 'warning':
					iconWrap = this.darkIconWrap;
					break;
				default:
					iconWrap = this.lightIconWrap;
					break;
			}
			
			this.iconMarkup = HEIJS.formatString(this.iconMarkup, iconWrap, this.iconCss);
			this.notyTemplate = HEIJS.formatString(this.notyTemplate, this.iconMarkup);
			this.notyTemplate = this.notyTemplate.replace('noty_text', 'noty_text noty_text_hasicon');
			this.notyObj['template'] = this.notyTemplate;
		}
		this.notyObj['text'] = (!this.title ? '' : this.title) + (this.messages.length <= 0 ? '' : this.createListFromArray(this.messages).get(0).outerHTML);
		this.messages = [];
    return this.container && this.container.length > 0 ? this.container.noty(this.notyObj) : noty(this.notyObj);
	}
	this.messages = [];
	return null;
  },

  setupEvents: function ()
  {
    var self = this;
		
	// do something... eventually...
  }
};

$(document).ready(
  function ()
  {
    HEIJS.page.NotyMessage = new HEIJS.Controls.NotyMessage();
	
	// setup page events to adjust for header?
  }
);